/**
 * CWS画像メンテ用VOクラス
 */
export class UpdateImageFileListModel {
  public imageFileList: Array<any> = new Array<any>();	// 更新対象画像ファイル情報
}
